import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { toast } from "sonner";

const Ctx = createContext(null);
const KEY = "fbs-compare";

export const CompareProvider = ({ children }) => {
  const [slugs, setSlugs] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  useEffect(() => localStorage.setItem(KEY, JSON.stringify(slugs)), [slugs]);

  const toggle = useCallback((slug, name) => {
    setSlugs((prev) => {
      if (prev.includes(slug)) return prev.filter((s) => s !== slug);
      if (prev.length >= 3) { toast("Compare holds up to three brokers", { description: "Remove one to add another." }); return prev; }
      toast(`${name} added to compare`);
      return [...prev, slug];
    });
  }, []);

  const clear = useCallback(() => setSlugs([]), []);
  return <Ctx.Provider value={{ slugs, toggle, clear, has: (s) => slugs.includes(s) }}>{children}</Ctx.Provider>;
};

export const useCompare = () => useContext(Ctx);
